
export default {
  monitorApi: {
    system: {
      getSystemInfo: 'api/monitor/system/getSystemInfo'
    },
    user: {
      //当前在线
      onlineUsers: 'api/monitor/user/onlineUsers',
      //强制下线
      offline: 'api/monitor/user/offline',
      //锁定用户
      lockedUsers: 'api/monitor/user/lockedUsers',
      unlock: 'api/monitor/user/unlock'
    },
    file: {
      getLogs: 'api/monitor/file/getLogs',
      downloadLog: 'api/monitor/file/downloadLog'
    }
  }
}